module.exports = __webpack_public_path__ + "img/toqoo-green.1de19e4f.svg";